import { createContext } from "react";

export type NotificationContetType = {
  exhibitorsNumber?: number;
  productInfo?: {
    productName?: string;
    cartPath?: string;
  };
  setExhibitorsNumber: (arg0: number) => void;
  setProductInfo: (productInfo: {
    productName: string;
    cartPath: string;
  }) => void;
};
export const NotificationContext = createContext<NotificationContetType>({
  exhibitorsNumber: 0,
  productInfo: {
    productName: "",
    cartPath: "",
  },
  setExhibitorsNumber: () => null,
  setProductInfo: () => null,
});
